/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { getTableConfiguration } from '../../../../utils/universalTracker'
import { BaseInputProps, TableInputProps, TableValueDataData } from './InputProps';
import SingleRowTableInput from './table/SingleRowTableInput';
import MultiRowTableInput from './table/MultiRowTableInput';
import './TableInput.scss';
import { QUESTION } from '@constants/terminology';
import { ValueTable } from '../../../../types/universalTracker';

export default function TableInput(props: BaseInputProps) {

  const { universalTracker } = props;
  const tableConfiguration: ValueTable | undefined = getTableConfiguration(universalTracker, true)
  const calculationColumns = React.useMemo(() => {
    if (!tableConfiguration) {
      return [];
    }
    return tableConfiguration.columns.filter((c) => c.calculation?.formula)
  }, [tableConfiguration])

  const visibilityRuleColumns = React.useMemo(() => {
    if (!tableConfiguration) {
      return [];
    }
    const columns = tableConfiguration.columns.filter((c) => c.visibilityRule?.formula);
    return columns;
  }, [tableConfiguration]);

  const disabledRuleColumns = React.useMemo(() => {
    if (!tableConfiguration) {
      return [];
    }
    const columns = tableConfiguration.columns.filter((c) => c.disabledRule?.formula);
    return columns;
  }, [tableConfiguration]);

  if (!tableConfiguration || !props.table) {
    return <div className='input-group'>
      <span>Unsupported {QUESTION.SINGULAR}</span>
    </div>;
  }

  const valueDataData = props.valueDataData
  if (valueDataData && !Array.isArray(valueDataData)) {
    return <div className='input-group'>
      <span>Unsupported table {QUESTION.SINGULAR}</span>
    </div>;
  }

  const mergedProps: TableInputProps = {
    ...props,
    valueDataData: valueDataData as TableValueDataData,
    calculationColumns,
    visibilityRuleColumns,
    disabledRuleColumns,
    tableConfiguration,
  }

  // Aggregated answers can hold several rows; they are read-only, so show them all as a table
  // TODO: GU-7297 older answers entered before maxRows: 1 can also hold several rows, but still show only row 0
  const isAggregateWithRows = props.isAggregate && props.table.rows.length > 1;
  if (tableConfiguration.validation?.maxRows === 1 && !isAggregateWithRows) {
    return <SingleRowTableInput {...mergedProps} />
  }

  return <MultiRowTableInput {...mergedProps} />
}
